"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _Field = _interopRequireDefault(require("../Field"));

var _classnames = _interopRequireDefault(require("classnames"));

var _warningOnce = _interopRequireDefault(require("../../_utils/warningOnce"));

var _withFormContext = _interopRequireDefault(require("../_utils/withFormContext"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var checkLabel = function checkLabel(label) {
  (0, _warningOnce.default)(label.trim() !== '', "<Form.Item> n'a pas \xE9t\xE9 pr\xE9vu pour \xEAtre utilis\xE9 avec un label vide (`label=\"\"`), " + "utilisez plut\xF4t <Form.Field> pour \xE7a.");
};

var FormItem = function (_React$Component) {
  (0, _inherits2.default)(FormItem, _React$Component);

  var _super = _createSuper(FormItem);

  function FormItem() {
    (0, _classCallCheck2.default)(this, FormItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      checkLabel(this.props.label);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.label !== this.props.label) {
        checkLabel(this.props.label);
      }
    }
  }, {
    key: "getId",
    value: function getId() {
      if (this.props.id) {
        return this.props.id;
      }

      return this._getChildProp('id');
    }
  }, {
    key: "_getControls",
    value: function _getControls(children) {
      var controls = [];
      var childrenArray = React.Children.toArray(children);

      for (var i = 0; i < childrenArray.length; i += 1) {
        if (controls.length > 0) {
          break;
        }

        var child = childrenArray[i];

        if (!React.isValidElement(child)) {
          continue;
        }

        if (child.type && child.type.isFormControl) {
          controls.push(child);
        } else if (child.props.children) {
          controls = controls.concat(this._getControls(child.props.children));
        }
      }

      return controls;
    }
  }, {
    key: "_getFirstControl",
    value: function _getFirstControl() {
      var child = this._getControls(this.props.children)[0];

      return child !== undefined ? child : null;
    }
  }, {
    key: "_getChildProp",
    value: function _getChildProp(prop) {
      var child = this._getFirstControl();

      if (!child || !child.props || !child.props[prop]) {
        return null;
      }

      return child.props[prop];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          required = _this$props.required,
          label = _this$props.label,
          help = _this$props.help,
          error = _this$props.error,
          formContext = _this$props.formContext,
          children = _this$props.children;
      var vertical = formContext.vertical;
      var hasHelp = help || error && error !== true;

      var _className = (0, _classnames.default)(className, 'FormItem', {
        'FormItem--required': required,
        'FormItem--vertical': vertical,
        'FormItem--error': !!error,
        'FormItem--with-help': hasHelp
      });

      return React.createElement("div", {
        className: _className
      }, React.createElement("label", {
        className: "FormItem__label",
        htmlFor: this.getId()
      }, label), React.createElement(_Field.default, {
        className: "FormItem__field",
        help: help,
        error: error
      }, children));
    }
  }]);
  return FormItem;
}(React.Component);

FormItem.displayName = 'Form.Item';
FormItem.defaultProps = {
  id: undefined,
  required: false,
  className: undefined,
  help: undefined,
  error: undefined
};

var _withContext = function _withContext(Component) {
  return (0, _withFormContext.default)(Component);
};

var _default = _withContext(FormItem);

exports.default = _default;